<!--begin::Main-->
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
    <!--begin::Content wrapper-->
    <div class="d-flex flex-column flex-column-fluid">
        <!--begin::Toolbar-->
        <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
            <!--begin::Toolbar container-->
            <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                <!--begin::Page title-->
                <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <!--begin::Title-->
                    <div class="d-flex align-items-center">
                        <h1 class="page-heading">
                            <svg width="44" height="42" viewBox="0 0 44 42" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_855_1927)">
                                    <path
                                        d="M18.721 18.1916L20.1507 16.7613C20.5248 16.3873 20.7305 15.8908 20.7305 15.3617C20.7305 14.8327 20.5248 14.3362 20.1507 13.9622C19.4033 13.2147 18.0997 13.2141 17.3516 13.9622L15.791 15.2429C16.2266 15.8081 16.7043 16.3589 17.2292 16.8837C17.71 17.3645 18.2125 17.791 18.721 18.1916Z"
                                        fill="#265D91" />
                                    <path
                                        d="M19.6724 4.38366C17.4488 3.80213 15.5672 4.13874 14.3734 5.33319C13.1795 6.52703 12.8417 8.40919 13.4238 10.6316C13.7623 11.925 14.3951 13.2479 15.2589 14.5117L16.746 13.2931C17.2575 12.7786 17.982 12.4781 18.7524 12.4781C19.5228 12.4781 20.2473 12.7786 20.7914 13.3227C21.3361 13.8674 21.636 14.5919 21.636 15.3617C21.636 16.1315 21.3355 16.8566 20.7914 17.4007L19.4522 18.7399C21.5051 20.1702 23.6713 20.9484 25.5113 20.9484C26.8197 20.9484 27.9635 20.5587 28.7821 19.7407C31.1795 17.3434 29.8975 12.1614 25.9251 8.189C24.0303 6.29417 21.8097 4.94288 19.6724 4.38306V4.38366Z"
                                        fill="#265D91" />
                                    <path
                                        d="M14.9489 26.2933C14.9489 26.1733 14.9013 26.058 14.8162 25.9736L8.14059 19.298C7.96384 19.1212 7.67729 19.1212 7.50054 19.298L4.71893 22.0796C3.76036 23.0382 3.76036 24.5982 4.71893 25.5567L8.55744 29.3953C9.51601 30.3538 11.076 30.3538 12.0346 29.3953L14.8162 26.6136C14.9013 26.5286 14.9489 26.4128 14.9489 26.2933Z"
                                        fill="#265D91" />
                                    <path
                                        d="M39.7465 0.420861C39.729 0.171113 39.5052 -0.0195155 39.2633 0.00159848L37.2014 0.146983C36.9522 0.164477 36.764 0.381046 36.7821 0.63019C36.7996 0.879938 37.0162 1.06574 37.2653 1.04945L38.2571 0.979475L34.6822 4.38545L32.9484 2.98349C32.7729 2.84112 32.5201 2.85017 32.3554 3.004L28.8077 6.30682C28.6249 6.47694 28.6146 6.76348 28.7847 6.94627C28.9555 7.12966 29.242 7.13871 29.4242 6.96919L32.6842 3.93422L34.4216 5.3386C34.5983 5.48157 34.8535 5.47192 35.0182 5.31447L38.9218 1.5948L38.9888 2.54673C39.0057 2.79648 39.2259 2.98469 39.472 2.96599C39.7212 2.9485 39.9094 2.73193 39.8913 2.48279L39.7465 0.420861Z"
                                        fill="#265D91" />
                                    <path
                                        d="M15.7766 26.9334L13.0366 29.6734L16.7949 33.4317C17.5574 34.1996 18.8182 34.1489 19.5349 33.3448C19.889 32.9907 20.0844 32.5189 20.0844 32.0182C20.0844 31.5175 19.889 31.0458 19.5349 30.6917L15.7766 26.9334Z"
                                        fill="#265D91" />
                                    <path
                                        d="M12.549 10.8602C12.4253 10.3878 12.3518 9.93238 12.3023 9.48718L8.11328 17.9991C8.12173 18.0063 16.1088 25.9675 16.1155 26.0007L24.6159 21.8177C21.9743 21.5275 19.0382 19.9718 16.5908 17.5237C14.5844 15.5167 13.1487 13.1501 12.549 10.8602Z"
                                        fill="#265D91" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_855_1927" x="0" y="0" width="43.8926" height="41.9789"
                                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_855_1927" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_855_1927"
                                            result="shape" />
                                    </filter>
                                </defs>
                            </svg>

                            Alerte
                        </h1>
                        <!--begin::Menu-->
                    </div>
                    <!--end::Title-->
                    <!--begin::Breadcrumb-->
                    <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">
                            <a href="/accueil" class="text-muted text-hover-primary">Accueil</a>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item">
                            <span class="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">appels d’offre</li>
                        <!--end::Item-->
                    </ul>
                    <!--end::Breadcrumb-->
                </div>
                <!--end::Page title-->
                <!--begin::Actions-->

                <!--end::Actions-->
            </div>
            <!--end::Toolbar container-->
        </div>
        <!--end::Toolbar-->
        <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container container-fluid">
                <!--begin::Card-->
                <div class="card">
                    <!--begin::Card header-->

                    <div class="card-body tools">
                        <div class="title mb-10">
                            <h4>Historique des vues sur les offres</h4>
                        </div>
                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <div class="input-shadow mb-3">
                                    <input type="text" name="search" id="search" class="form-control mb-3"
                                        placeholder="Rechercher">
                                </div>
                            </div>
                            <div class="col-lg-3 rechercher">
                            </div>
                            <div class="col-lg-4">
                            </div>
                        </div>
                        <!--begin::Card header-->
                        <div class="d-flex flex-wrap my-1 header-grid align-items-center">
                            <div class="section_title">
                            </div>
                            <!--begin::Tab nav-->
                            <ul class="nav nav-pills me-5">
                                <li class="nav-item m-0">
                                    <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary me-3"
                                        data-bs-toggle="tab" href="#kt_project_targets_card_pane">
                                        <i class="ki-duotone ki-element-plus fs-1">
                                            <span class="path1"></span>
                                            <span class="path2"></span>
                                            <span class="path3"></span>
                                            <span class="path4"></span>
                                            <span class="path5"></span>
                                        </i>
                                    </a>
                                </li>
                                <li class="nav-item m-0">
                                    <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
                                        data-bs-toggle="tab" href="#kt_project_targets_table_pane">
                                        <i class="ki-duotone ki-row-horizontal fs-2">
                                            <span class="path1"></span>
                                            <span class="path2"></span>
                                        </i>
                                    </a>
                                </li>
                            </ul>
                            <!--end::Tab nav-->
                            <!--begin::Wrapper-->

                            <!--end::Wrapper-->
                        </div>
                        <!--end::Card header-->
                        <div class="tab-content">
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_card_pane" class="tab-pane fade">
                                <!--begin::Row-->
                                <div class="row g-6 g-xl-9 justify-content-center">
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="tools">
                                                <td class="actions">
                                                    <div class="tools">
                                                        <div class="dropdown">
                                                            <button
                                                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                                type="button" id="dropdownMenuButton"
                                                                data-bs-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                <svg width="19" height="5" viewBox="0 0 19 5"
                                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 0 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                        fill="#265D91" />
                                                                </svg>
                                                            </button>
                                                  
                                                        </div>
                                                    </div>
                                                </td>
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <img src="assets/media//avatars/300-2.jpg" alt="image" />
                                                   
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">Samia
                                                    Meddeb
                                                </a>
                                                <!--end::Name-->
                                                <!--begin::Position-->
                                                <!--end::Position-->
                                                <!--begin::Info-->
                                                <div class="d-flex flex-center flex-wrap mt-5">
                                                    <!--begin::Stats-->
                                                    <div class="skills">
                                                        <div class="skill">
                                                            <span class="badge style1">Python</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style2">Laravel</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style3">C#</span>
                                                        </div>
                                                    </div>
                                                    <!--end::Stats-->
                                                </div>

                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                                <div class="poste">
                                                    <span> Poste 1 </span>
                                                </div>
                                                <div class="plus">
                                                    <a>Voir plus</a>
                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="tools">
                                                <td class="actions">
                                                    <div class="tools">
                                                        <div class="dropdown">
                                                            <button
                                                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                                type="button" id="dropdownMenuButton"
                                                                data-bs-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                <svg width="19" height="5" viewBox="0 0 19 5"
                                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 0 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                        fill="#265D91" />
                                                                </svg>
                                                            </button>
                                                 
                                                        </div>
                                                    </div>
                                                </td>
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <img src="assets/media//avatars/300-2.jpg" alt="image" />
                                                    <div
                                                        class="bg-success position-absolute border border-4 border-body h-15px w-15px rounded-circle translate-middle start-100 top-100 ms-n3 mt-n3">
                                                    </div>
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">Samia
                                                    Meddeb
                                                </a>
                                            
                                                <div class="d-flex flex-center flex-wrap mt-5">
                                                    <!--begin::Stats-->
                                                    <div class="skills">
                                                        <div class="skill">
                                                            <span class="badge style1">Python</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style2">Laravel</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style3">C#</span>
                                                        </div>
                                                    </div>
                                                    <!--end::Stats-->
                                                </div>

                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                                <div class="poste">
                                                    <span> Poste 1 </span>
                                                </div>
                                                <div class="plus">
                                                    <a>Voir plus</a>
                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="tools">
                                                <td class="actions">
                                                    <div class="tools">
                                                        <div class="dropdown">
                                                            <button
                                                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                                type="button" id="dropdownMenuButton"
                                                                data-bs-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                <svg width="19" height="5" viewBox="0 0 19 5"
                                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 0 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                        fill="#265D91" />
                                                                </svg>
                                                            </button>
                                              
                                                        </div>
                                                    </div>
                                                </td>
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <img src="assets/media//avatars/300-2.jpg" alt="image" />
                                                    <div
                                                        class="bg-success position-absolute border border-4 border-body h-15px w-15px rounded-circle translate-middle start-100 top-100 ms-n3 mt-n3">
                                                    </div>
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">Samia
                                                    Meddeb
                                                </a>
                                                <!--end::Name-->
                                                <!--begin::Position-->
                                                <!--end::Position-->
                                                <!--begin::Info-->
                                                <div class="d-flex flex-center flex-wrap mt-5">
                                                    <!--begin::Stats-->
                                                    <div class="skills">
                                                        <div class="skill">
                                                            <span class="badge style1">Python</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style2">Laravel</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style3">C#</span>
                                                        </div>
                                                    </div>
                                                    <!--end::Stats-->
                                                </div>

                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                                <div class="poste">
                                                    <span> Poste 1 </span>
                                                </div>
                                                <div class="plus">
                                                    <a>Voir plus</a>
                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="tools">
                                                <td class="actions">
                                                    <div class="tools">
                                                        <div class="dropdown">
                                                            <button
                                                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                                type="button" id="dropdownMenuButton"
                                                                data-bs-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                <svg width="19" height="5" viewBox="0 0 19 5"
                                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 0 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                        fill="#265D91" />
                                                                </svg>
                                                            </button>
                                                      
                                                        </div>
                                                    </div>
                                                </td>
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <img src="assets/media//avatars/300-2.jpg" alt="image" />
                                                    <div
                                                        class="bg-success position-absolute border border-4 border-body h-15px w-15px rounded-circle translate-middle start-100 top-100 ms-n3 mt-n3">
                                                    </div>
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">Samia
                                                    Meddeb
                                                </a>
                                                <!--end::Name-->
                                                <!--begin::Position-->
                                                <!--end::Position-->
                                                <!--begin::Info-->
                                                <div class="d-flex flex-center flex-wrap mt-5">
                                                    <!--begin::Stats-->
                                                    <div class="skills">
                                                        <div class="skill">
                                                            <span class="badge style1">Python</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style2">Laravel</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style3">C#</span>
                                                        </div>
                                                    </div>
                                                    <!--end::Stats-->
                                                </div>

                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                                <div class="poste">
                                                    <span> Poste 1 </span>
                                                </div>
                                                <div class="plus">
                                                    <a>Voir plus</a>
                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="tools">
                                                <td class="actions">
                                                    <div class="tools">
                                                        <div class="dropdown">
                                                            <button
                                                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                                type="button" id="dropdownMenuButton"
                                                                data-bs-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                <svg width="19" height="5" viewBox="0 0 19 5"
                                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 0 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                        fill="#265D91" />
                                                                </svg>
                                                            </button>
                                                       
                                                        </div>
                                                    </div>
                                                </td>
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <img src="assets/media//avatars/300-2.jpg" alt="image" />
                                                    <div
                                                        class="bg-success position-absolute border border-4 border-body h-15px w-15px rounded-circle translate-middle start-100 top-100 ms-n3 mt-n3">
                                                    </div>
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">Samia
                                                    Meddeb
                                                </a>
                                                <!--end::Name-->
                                                <!--begin::Position-->
                                                <!--end::Position-->
                                                <!--begin::Info-->
                                                <div class="d-flex flex-center flex-wrap mt-5">
                                                    <!--begin::Stats-->
                                                    <div class="skills">
                                                        <div class="skill">
                                                            <span class="badge style1">Python</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style2">Laravel</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style3">C#</span>
                                                        </div>
                                                    </div>
                                                    <!--end::Stats-->
                                                </div>

                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                                <div class="poste">
                                                    <span> Poste 1 </span>
                                                </div>
                                                <div class="plus">
                                                    <a>Voir plus</a>
                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="tools">
                                                <td class="actions">
                                                    <div class="tools">
                                                        <div class="dropdown">
                                                            <button
                                                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                                type="button" id="dropdownMenuButton"
                                                                data-bs-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                <svg width="19" height="5" viewBox="0 0 19 5"
                                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 0 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                        fill="#265D91" />
                                                                </svg>
                                                            </button>
                                                        
                                                        </div>
                                                    </div>
                                                </td>
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <img src="assets/media//avatars/300-2.jpg" alt="image" />
                                                    <div
                                                        class="bg-success position-absolute border border-4 border-body h-15px w-15px rounded-circle translate-middle start-100 top-100 ms-n3 mt-n3">
                                                    </div>
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">Samia
                                                    Meddeb
                                                </a>
                                                <!--end::Name-->
                                                <!--begin::Position-->
                                                <!--end::Position-->
                                                <!--begin::Info-->
                                                <div class="d-flex flex-center flex-wrap mt-5">
                                                    <!--begin::Stats-->
                                                    <div class="skills">
                                                        <div class="skill">
                                                            <span class="badge style1">Python</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style2">Laravel</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style3">C#</span>
                                                        </div>
                                                    </div>
                                                    <!--end::Stats-->
                                                </div>

                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                                <div class="poste">
                                                    <span> Poste 1 </span>
                                                </div>
                                                <div class="plus">
                                                    <a>Voir plus</a>
                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="tools">
                                                <td class="actions">
                                                    <div class="tools">
                                                        <div class="dropdown">
                                                            <button
                                                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                                type="button" id="dropdownMenuButton"
                                                                data-bs-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                <svg width="19" height="5" viewBox="0 0 19 5"
                                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 0 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                        fill="#265D91" />
                                                                </svg>
                                                            </button>
                                                        
                                                        </div>
                                                    </div>
                                                </td>
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <img src="assets/media//avatars/300-2.jpg" alt="image" />
                                                    <div
                                                        class="bg-success position-absolute border border-4 border-body h-15px w-15px rounded-circle translate-middle start-100 top-100 ms-n3 mt-n3">
                                                    </div>
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">Samia
                                                    Meddeb
                                                </a>
                                                <!--end::Name-->
                                                <!--begin::Position-->
                                                <!--end::Position-->
                                                <!--begin::Info-->
                                                <div class="d-flex flex-center flex-wrap mt-5">
                                                    <!--begin::Stats-->
                                                    <div class="skills">
                                                        <div class="skill">
                                                            <span class="badge style1">Python</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style2">Laravel</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style3">C#</span>
                                                        </div>
                                                    </div>
                                                    <!--end::Stats-->
                                                </div>

                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                                <div class="poste">
                                                    <span> Poste 1 </span>
                                                </div>
                                                <div class="plus">
                                                    <a>Voir plus</a>
                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="tools">
                                                <td class="actions">
                                                    <div class="tools">
                                                        <div class="dropdown">
                                                            <button
                                                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                                type="button" id="dropdownMenuButton"
                                                                data-bs-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                <svg width="19" height="5" viewBox="0 0 19 5"
                                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 0 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                        fill="#265D91" />
                                                                </svg>
                                                            </button>
                                                    
                                                        </div>
                                                    </div>
                                                </td>
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <img src="assets/media//avatars/300-2.jpg" alt="image" />
                                                    <div
                                                        class="bg-success position-absolute border border-4 border-body h-15px w-15px rounded-circle translate-middle start-100 top-100 ms-n3 mt-n3">
                                                    </div>
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">Samia
                                                    Meddeb
                                                </a>
                                                <!--end::Name-->
                                                <!--begin::Position-->
                                                <!--end::Position-->
                                                <!--begin::Info-->
                                                <div class="d-flex flex-center flex-wrap mt-5">
                                                    <!--begin::Stats-->
                                                    <div class="skills">
                                                        <div class="skill">
                                                            <span class="badge style1">Python</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style2">Laravel</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style3">C#</span>
                                                        </div>
                                                    </div>
                                                    <!--end::Stats-->
                                                </div>

                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                                <div class="poste">
                                                    <span> Poste 1 </span>
                                                </div>
                                                <div class="plus">
                                                    <a>Voir plus</a>
                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="tools">
                                                <td class="actions">
                                                    <div class="tools">
                                                        <div class="dropdown">
                                                            <button
                                                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                                type="button" id="dropdownMenuButton"
                                                                data-bs-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                <svg width="19" height="5" viewBox="0 0 19 5"
                                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 0 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                        fill="#265D91" />
                                                                </svg>
                                                            </button>
                                                      
                                                        </div>
                                                    </div>
                                                </td>
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <img src="assets/media//avatars/300-2.jpg" alt="image" />
                                                    <div
                                                        class="bg-success position-absolute border border-4 border-body h-15px w-15px rounded-circle translate-middle start-100 top-100 ms-n3 mt-n3">
                                                    </div>
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">Samia
                                                    Meddeb
                                                </a>
                                                <!--end::Name-->
                                                <!--begin::Position-->
                                                <!--end::Position-->
                                                <!--begin::Info-->
                                                <div class="d-flex flex-center flex-wrap mt-5">
                                                    <!--begin::Stats-->
                                                    <div class="skills">
                                                        <div class="skill">
                                                            <span class="badge style1">Python</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style2">Laravel</span>
                                                        </div>
                                                        <div class="skill">
                                                            <span class="badge style3">C#</span>
                                                        </div>
                                                    </div>
                                                    <!--end::Stats-->
                                                </div>

                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                                <div class="poste">
                                                    <span> Poste 1 </span>
                                                </div>
                                                <div class="plus">
                                                    <a>Voir plus</a>
                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->
                                </div>
                                <!--end::Row-->
                            </div>
                            <!--end::Tab pane-->
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                                <div class="content">
                                    <!--begin::Card body-->
                                    <div class="card-body">
                                        <!--begin::Table-->
                                        <div class="table-responsive">
                                            <table class="table align-middle fs-6 gy-5 style-table"
                                                id="kt_customers_table">
                                                <thead>
                                                    <tr
                                                        class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                        <th></th>
                                                        <th class="min-w-125px">Nom client</th>
                                                        <th class="min-w-125px">email</th>
                                                        <th class="min-w-150px">Date</th>
                                                        <th class="min-w-125px">Actions</th>
                                                        <th class="min-w-90px">
                                                            <div class="dropdown" id="table-filter">
                                                                <button
                                                                    class="btn btn-sm  btn-flex btn-centerdropdown-toggle"
                                                                    type="button" id="dropdownMenuButton"
                                                                    data-bs-toggle="dropdown" aria-haspopup="true"
                                                                    aria-expanded="false">
                                                                    <svg width="28" height="28" viewBox="0 0 28 28"
                                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g filter="url(#filter0_d_444_2002)">
                                                                            <rect x="4" width="20" height="20" rx="4"
                                                                                fill="#63C3E8" fill-opacity="0.12"
                                                                                shape-rendering="crispEdges" />
                                                                        </g>
                                                                        <path
                                                                            d="M17.5 10.6H14.6V13.5C14.6 13.8314 14.3314 14.1 14 14.1C13.6686 14.1 13.4 13.8314 13.4 13.5V10.6H10.5C10.1686 10.6 9.9 10.3314 9.9 10C9.9 9.66863 10.1686 9.4 10.5 9.4H13.4V6.5C13.4 6.16863 13.6686 5.9 14 5.9C14.3314 5.9 14.6 6.16863 14.6 6.5V9.4H17.5C17.8314 9.4 18.1 9.66863 18.1 10C18.1 10.3314 17.8314 10.6 17.5 10.6Z"
                                                                            fill="#265D91" stroke="#265D91"
                                                                            stroke-width="0.2" />
                                                                        <defs>
                                                                            <filter id="filter0_d_444_2002" x="0" y="0"
                                                                                width="28" height="28"
                                                                                filterUnits="userSpaceOnUse"
                                                                                color-interpolation-filters="sRGB">
                                                                                <feFlood flood-opacity="0"
                                                                                    result="BackgroundImageFix" />
                                                                                <feColorMatrix in="SourceAlpha"
                                                                                    type="matrix"
                                                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                                                    result="hardAlpha" />
                                                                                <feOffset dy="4" />
                                                                                <feGaussianBlur stdDeviation="2" />
                                                                                <feComposite in2="hardAlpha"
                                                                                    operator="out" />
                                                                                <feColorMatrix type="matrix"
                                                                                    values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.13 0" />
                                                                                <feBlend mode="normal"
                                                                                    in2="BackgroundImageFix"
                                                                                    result="effect1_dropShadow_444_2002" />
                                                                                <feBlend mode="normal"
                                                                                    in="SourceGraphic"
                                                                                    in2="effect1_dropShadow_444_2002"
                                                                                    result="shape" />
                                                                            </filter>
                                                                        </defs>
                                                                    </svg>
                                                                </button>
                                                                <div class="dropdown-menu"
                                                                    aria-labelledby="dropdownMenuButton">
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            Nom client
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            email
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            Date
                                                                        </label>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody class="fw-semibold text-gray-600">
                                                    <tr>
                                                        <td>
                                                            <img src="/assets/media/icons/avatar.jpg" alt="" width="75px">
                                                        </td>
                                                        <td><span>Client 1</span></td>
                                                        <td><span class="color-blue">cliect.com</span></td>
                                                        <td>
                                                            <span>12/08/2023</span>
                                                        </td>

                                                        <td>
                                                            <button type="button" class="btn btn-details"> Voir profil
                                                            </button>
                                                        </td>
                                                    
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <img src="/assets/media/icons/avatar.jpg" alt="" width="75px">
                                                        </td>
                                                        <td><span>Client 1</span></td>
                                                        <td><span class="color-blue">cliect</span></td>
                                                        <td>
                                                            <span>12/08/2023</span>
                                                        </td>

                                                        <td>
                                                            <button type="button" class="btn btn-details"> Voir profil
                                                            </button>
                                                        </td>
                                            
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <img src="/assets/media/icons/avatar.jpg" alt="" width="75px">
                                                        </td>
                                                        <td><span>Client 1</span></td>
                                                        <td><span class="color-blue">.com</span></td>
                                                        <td>
                                                            <span>12/08/2023</span>
                                                        </td>

                                                        <td>
                                                            <button type="button" class="btn btn-details"> Voir profil
                                                            </button>
                                                        </td>
                                                  
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <img src="/assets/media/icons/avatar.jpg" alt="" width="75px">
                                                        </td>
                                                        <td><span>Client 1</span></td>
                                                        <td><span class="color-blue">cliect.com</span></td>
                                                        <td>
                                                            <span>12/08/2023</span>
                                                        </td>

                                                        <td>
                                                            <button type="button" class="btn btn-details"> Voir profil
                                                            </button>
                                                        </td>
                                                 
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!--end::Table-->
                                    </div>
                                    <!--end::Card body-->
                                </div>
                            </div>
                            <!--end::Tab pane-->
                        </div>
                        <!--end::Table-->


                    </div>
                </div>
            </div>
            <!--end::Content container-->
        </div>
        <!--begin::Content-->


        <!--end::Content-->
    </div>
    <!--end::Content wrapper-->
    <!--begin::Footer-->

    <!--end::Footer-->
    <!--end:::Main-->
</div>
